import { HintAnimation } from '../../portal-hints/hint-motion';
import { HINT_FILMS, HintId } from '../../portal-hints/hint-films';
import { KNOWLEDGE_SCENES } from './knowledge-scenes';
import { ESSENTIALS_SCENES } from './essentials-scenes';
import { ADVANCED_SCENES } from './advanced-scenes';
import { CREATOR_SCENES } from './creator-scenes';

/** Alle Academy-Szenen je ID (Themen 1–8). */
export const LESSON_SCENES = { ...ESSENTIALS_SCENES, ...KNOWLEDGE_SCENES, ...ADVANCED_SCENES, ...CREATOR_SCENES } satisfies Record<string, () => HintAnimation>;

export type SceneId = keyof typeof LESSON_SCENES;

/** Eine Szene eines Lektionsfilms: der Hinweis-Film (`hint:<id>`, ein
 *  Durchlauf) oder eine Academy-Szene (`scene:<id>`). */
export type FilmRef = `hint:${HintId}` | `scene:${SceneId}`;

export function filmFor(ref: FilmRef): HintAnimation {
  const [kind, id] = ref.split(':') as ['hint' | 'scene', string];
  const factory = kind === 'hint' ? HINT_FILMS[id as HintId] : LESSON_SCENES[id as SceneId];
  return factory();
}
